import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { useFormikContext } from "formik";
import { Icon, Accordion, AccordionItem } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import AbsoluteCalendar from "./AbsoluteCalendar";
import AbsoluteTimestamp from "./AbsoluteTimestamp";
const AbsoluteWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-around;
`;
const RangeWrapper = styled.div`
  flex: 4;
  align-items: center;
  display: flex;
  flex-direction: column;

  .DayPicker-wrapper {
    padding-bottom: 0;
  }
`;
const IconWrap = styled.div`
  flex: 0.75;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-0.65em);
`;
const StyledAccordion = styled(Accordion)`
  width: 100%;

  .panel-body {
    display: flex;
  }
`;
const TimestampContent = styled.div`
  flex: 1;
`;
const FlexWrap = styled.div`
  display: flex;
`;
const TabAbsoluteTimeRange = ({ disabled = false, limitDuration = 0 }) => {
  const { t } = useTranslation("search");
  const {
    values: { timeRangeTabs }
  } = useFormikContext();
  const activeTabTimeRange = timeRangeTabs.absolute;
  const { toUserTimezone } = useUserDateTime();
  const [activeAccordion, setActiveAccordion] = useState();
  const toStartDate = moment(activeTabTimeRange.from).toDate();
  const fromStartDate = limitDuration ? toUserTimezone(/* @__PURE__ */ new Date()).seconds(-limitDuration).toDate() : void 0;
  const handleSelect = (nextKey) => {
    setActiveAccordion(nextKey != null ? nextKey : activeAccordion);
  };
  return /* @__PURE__ */ React.createElement(AbsoluteWrapper, null, /* @__PURE__ */ React.createElement(
    StyledAccordion,
    {
      defaultActiveKey: "calendar",
      onSelect: handleSelect,
      id: "absolute-time-ranges",
      "data-testid": "absolute-time-ranges",
      activeKey: activeAccordion
    },
    /* @__PURE__ */ React.createElement(AccordionItem, { name: t("time_range.calendar"), id: "calendar" }, /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(AbsoluteCalendar, { startDate: fromStartDate, timeRange: activeTabTimeRange, range: "from" })), /* @__PURE__ */ React.createElement(IconWrap, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right_alt" })), /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(AbsoluteCalendar, { startDate: toStartDate, timeRange: activeTabTimeRange, range: "to" }))),
    /* @__PURE__ */ React.createElement(AccordionItem, { name: t("time_range.timestamp"), id: "timestamp" }, /* @__PURE__ */ React.createElement(TimestampContent, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "time_range.date_format",
        values: { format: "YYYY-MM-DD [HH:mm:ss[.SSS]]" },
        components: { code: /* @__PURE__ */ React.createElement("code", null) }
      }
    )), /* @__PURE__ */ React.createElement(FlexWrap, null, /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(
      AbsoluteTimestamp,
      {
        disabled,
        timeRange: activeTabTimeRange,
        range: "from",
        label: t("time_range.from_timestamp")
      }
    )), /* @__PURE__ */ React.createElement(IconWrap, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right_alt" })), /* @__PURE__ */ React.createElement(RangeWrapper, null, /* @__PURE__ */ React.createElement(
      AbsoluteTimestamp,
      {
        disabled,
        timeRange: activeTabTimeRange,
        range: "to",
        label: t("time_range.to_timestamp")
      }
    )))))
  ));
};
export default TabAbsoluteTimeRange;
